import BaseViewModel from "../../Core/BaseViewModel";
import TicketModel from "../../Models/TicketModel";

export default class TicketsViewModel extends  BaseViewModel{
	loading: boolean = false;
	tickets: TicketModel[] = [];
	orderid: any;
	totalPage:number=0;
	page: number=1;
}